/**
 * @generated SignedSource<<23818f5aa8b873c8bdff859ba6b1736e>>
 * @relayHash 0823488049ea540f2c3f5c4cb3a9f517
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e32f72b766dc4dbdcd33139b587c228b30663d8a6a179388fcc7ec57c1ddfaed

import type { ConcreteRequest, Query } from 'relay-runtime';
export type BlockedAccessSubjectType = "GROUP" | "USER" | "%future added value";
export type ResourceAccessType = "EDIT" | "VIEW" | "%future added value";
export type ResourceType = "DATABASE" | "FOLDER" | "PAGE" | "SLIDE" | "SPACE" | "WHITEBOARD" | "%future added value";
export type SpaceRoleType = "CUSTOM" | "SYSTEM" | "%future added value";
export type BlockedAccessSubjectInput = {
  subjectId: string;
  subjectType: BlockedAccessSubjectType;
};
export type BlockedAccessRestrictionsQuery$variables = {
  accessType: ResourceAccessType;
  contentId: AGG$Long;
  subjects: ReadonlyArray<BlockedAccessSubjectInput | null | undefined>;
};
export type BlockedAccessRestrictionsQuery$data = {
  readonly blockedAccessRestrictions: {
    readonly blockedAccessAssignableSpaceRolesIntersection: ReadonlyArray<{
      readonly roleDescription: string;
      readonly roleId: string;
      readonly roleName: string;
      readonly roleType: SpaceRoleType;
    } | null | undefined>;
    readonly blockedAccessEmpowerment: ReadonlyArray<{
      readonly isCurrentUserEmpowered: boolean;
      readonly subjectId: string;
    } | null | undefined>;
    readonly blockedAccessRestrictionSummary: ReadonlyArray<{
      readonly restrictedResources: ReadonlyArray<{
        readonly requiredAccessType: ResourceAccessType | null | undefined;
        readonly resourceId: AGG$Long;
        readonly resourceLink: {
          readonly base: string | null | undefined;
          readonly webUi: string | null | undefined;
        };
        readonly resourceTitle: string;
        readonly resourceType: ResourceType;
      } | null | undefined> | null | undefined;
      readonly subject: {
        readonly subjectId: string;
        readonly subjectType: BlockedAccessSubjectType;
      } | null | undefined;
    } | null | undefined>;
    readonly canFixRestrictionsForAllSubjects: boolean;
  } | null | undefined;
};
export type BlockedAccessRestrictionsQuery = {
  response: BlockedAccessRestrictionsQuery$data;
  variables: BlockedAccessRestrictionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accessType"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "subjects"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "subjectId"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "accessType",
        "variableName": "accessType"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "subjects",
        "variableName": "subjects"
      }
    ],
    "concreteType": "BlockedAccessRestrictions",
    "kind": "LinkedField",
    "name": "blockedAccessRestrictions",
    "plural": false,
    "selections": [
      {
        "concreteType": "SubjectRestrictionHierarchySummary",
        "kind": "LinkedField",
        "name": "blockedAccessRestrictionSummary",
        "plural": true,
        "selections": [
          {
            "concreteType": "BlockedAccessSubject",
            "kind": "LinkedField",
            "name": "subject",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "subjectType"
              }
            ]
          },
          {
            "concreteType": "RestrictedResource",
            "kind": "LinkedField",
            "name": "restrictedResources",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "resourceId"
              },
              {
                "kind": "ScalarField",
                "name": "resourceTitle"
              },
              {
                "concreteType": "RestrictedResourceLinks",
                "kind": "LinkedField",
                "name": "resourceLink",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "base"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "webUi"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "requiredAccessType"
              },
              {
                "kind": "ScalarField",
                "name": "resourceType"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "BlockedAccessEmpowerment",
        "kind": "LinkedField",
        "name": "blockedAccessEmpowerment",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "isCurrentUserEmpowered"
          }
        ]
      },
      {
        "concreteType": "ConfluenceBlockedAccessAssignableSpaceRole",
        "kind": "LinkedField",
        "name": "blockedAccessAssignableSpaceRolesIntersection",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "roleId"
          },
          {
            "kind": "ScalarField",
            "name": "roleDescription"
          },
          {
            "kind": "ScalarField",
            "name": "roleName"
          },
          {
            "kind": "ScalarField",
            "name": "roleType"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "canFixRestrictionsForAllSubjects"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "BlockedAccessRestrictionsQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BlockedAccessRestrictionsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "0823488049ea540f2c3f5c4cb3a9f517",
    "id": "e32f72b766dc4dbdcd33139b587c228b30663d8a6a179388fcc7ec57c1ddfaed",
    "metadata": {},
    "name": "BlockedAccessRestrictionsQuery",
    "operationKind": "query",
    "text": "query BlockedAccessRestrictionsQuery($accessType:ResourceAccessType!,$contentId:Long!,$subjects:[BlockedAccessSubjectInput]!){blockedAccessRestrictions(accessType:$accessType,contentId:$contentId,subjects:$subjects){blockedAccessRestrictionSummary{subject{subjectId,subjectType},restrictedResources{resourceId,resourceTitle,resourceLink{base,webUi},requiredAccessType,resourceType}},blockedAccessEmpowerment{subjectId,isCurrentUserEmpowered},blockedAccessAssignableSpaceRolesIntersection{roleId,roleDescription,roleName,roleType},canFixRestrictionsForAllSubjects}}"
  }
};
})();

(node as any).hash = "cc9731fa07afd21d30e45e70eeb338f4";

export default node;
